var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "base-card",
    [
      _c("v-card-text", [
        _c(
          "div",
          {
            staticClass:
              "d-flex flex-column align-center justify-center text-center py-6",
          },
          [
            _c("h3", { staticClass: "mb-8" }, [
              _vm._v(
                "Generación Masiva de NC a partir de Facturas Electrónicas"
              ),
            ]),
            _c("v-select", {
              attrs: {
                items: _vm.filteredCompanies,
                dense: "",
                "item-text": "displayText",
                label: "Selecciona una compañía",
                "prepend-inner-icon": "mdi-domain",
                "return-object": "",
                solo: "",
              },
              on: { change: _vm.fetchToken },
              scopedSlots: _vm._u([
                {
                  key: "prepend-item",
                  fn: function () {
                    return [
                      _c(
                        "v-list-item",
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-text-field", {
                                staticClass: "mx-4",
                                attrs: {
                                  dense: "",
                                  "hide-details": "",
                                  placeholder: "Buscar compañía",
                                  "prepend-inner-icon": "mdi-magnify",
                                },
                                model: {
                                  value: _vm.search,
                                  callback: function ($$v) {
                                    _vm.search = $$v
                                  },
                                  expression: "search",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-divider", { staticClass: "mt-2" }),
                    ]
                  },
                  proxy: true,
                },
              ]),
              model: {
                value: _vm.selectedCompany,
                callback: function ($$v) {
                  _vm.selectedCompany = $$v
                },
                expression: "selectedCompany",
              },
            }),
            _vm.loadingToken
              ? _c("div", [_c("em", [_vm._v("Obteniendo token...")])])
              : _vm._e(),
          ],
          1
        ),
        _vm.token
          ? _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column align-center justify-center text-center py-6",
              },
              [
                _c(
                  "v-row",
                  { staticStyle: { width: "100%", "max-width": "900px" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12" } },
                      [
                        _c("v-combobox", {
                          attrs: {
                            hint: `${_vm.consecutivosFE.length} factura(s) agregada(s)`,
                            chips: "",
                            clearable: "",
                            "deletable-chips": "",
                            label: "Facturas FE",
                            multiple: "",
                            "persistent-hint": "",
                          },
                          on: { paste: _vm.handlePaste },
                          model: {
                            value: _vm.consecutivosFE,
                            callback: function ($$v) {
                              _vm.consecutivosFE = $$v
                            },
                            expression: "consecutivosFE",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "4" } },
                      [
                        _c("v-text-field", {
                          attrs: { label: "Serie Nota Crédito", outlined: "" },
                          model: {
                            value: _vm.serieNC,
                            callback: function ($$v) {
                              _vm.serieNC = $$v
                            },
                            expression: "serieNC",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "2" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "NC Inicial",
                            outlined: "",
                            type: "number",
                          },
                          model: {
                            value: _vm.ncInicio,
                            callback: function ($$v) {
                              _vm.ncInicio = $$v
                            },
                            expression: "ncInicio",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Número de Resolución",
                            outlined: "",
                          },
                          model: {
                            value: _vm.resolutionNumber,
                            callback: function ($$v) {
                              _vm.resolutionNumber = $$v
                            },
                            expression: "resolutionNumber",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticStyle: { width: "100%", "max-width": "900px" } },
                  [
                    _c(
                      "v-col",
                      { attrs: { cols: "12", md: "6" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Rango Resolución",
                            placeholder: "1 - 10000",
                            hint: _vm.resolutionRankPreview,
                            "persistent-hint": "",
                            outlined: "",
                          },
                          model: {
                            value: _vm.resolutionRange,
                            callback: function ($$v) {
                              _vm.resolutionRange = $$v
                            },
                            expression: "resolutionRange",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "v-row",
                  { staticStyle: { width: "100%", "max-width": "900px" } },
                  [
                    _c("v-col", { attrs: { cols: "12", md: "4" } }),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        attrs: { disabled: _vm.loading, color: "grey" },
                        on: { click: _vm.clearFields },
                      },
                      [_vm._v(" Limpiar ")]
                    ),
                    _c(
                      "v-btn",
                      {
                        staticClass: "ma-2",
                        staticStyle: {
                          "background-color": "rgb(204 33 40)",
                          color: "white !important",
                        },
                        attrs: { disabled: _vm.loading, loading: _vm.loading },
                        on: { click: _vm.generarNCs },
                      },
                      [_vm._v(" Generar NCs ")]
                    ),
                  ],
                  1
                ),
                _vm.loading
                  ? _c("v-progress-linear", {
                      staticClass: "my-4",
                      attrs: { color: "primary", indeterminate: "" },
                    })
                  : _vm._e(),
                _vm.alerta.mostrar
                  ? _c(
                      "v-alert",
                      {
                        staticClass: "my-4",
                        staticStyle: { "white-space": "pre-line" },
                        attrs: { type: _vm.alerta.tipo, dismissible: "" },
                        on: {
                          input: function ($event) {
                            _vm.alerta.mostrar = false
                          },
                        },
                      },
                      [_vm._v(" " + _vm._s(_vm.alerta.mensaje) + " ")]
                    )
                  : _vm._e(),
                _c(
                  "v-dialog",
                  {
                    attrs: { "max-width": "1400px", persistent: "" },
                    model: {
                      value: _vm.showModal,
                      callback: function ($$v) {
                        _vm.showModal = $$v
                      },
                      expression: "showModal",
                    },
                  },
                  [
                    _c(
                      "v-card",
                      [
                        _c(
                          "v-card-title",
                          [
                            _vm._v(" Resultado generación NCs "),
                            _c("v-spacer"),
                            _c(
                              "v-btn",
                              {
                                staticClass: "mr-2",
                                attrs: { color: "primary", small: "" },
                                on: { click: _vm.copyResults },
                              },
                              [
                                _c("v-icon", { attrs: { left: "" } }, [
                                  _vm._v("mdi-content-copy"),
                                ]),
                                _vm._v(" Copiar resultados "),
                              ],
                              1
                            ),
                            _c(
                              "v-btn",
                              {
                                attrs: { icon: "" },
                                on: {
                                  click: function ($event) {
                                    _vm.showModal = false
                                  },
                                },
                              },
                              [_c("v-icon", [_vm._v("mdi-close")])],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "v-card-text",
                          [
                            _c("v-simple-table", { attrs: { dense: "" } }, [
                              _c("thead", [
                                _c("tr", [
                                  _c("th", [_vm._v("Factura FE")]),
                                  _c("th", [_vm._v("Nota Crédito")]),
                                  _c("th", [_vm._v("CUFE FE")]),
                                  _c("th", [_vm._v("CUFE NC")]),
                                  _c("th", [_vm._v("Diferencia IVA")]),
                                  _c("th", [_vm._v("Diferencia Total")]),
                                  _c("th", [_vm._v("Estado")]),
                                  _c("th", [_vm._v("Mensaje")]),
                                ]),
                              ]),
                              _c(
                                "tbody",
                                _vm._l(_vm.resultados, function (item, index) {
                                  return _c("tr", { key: index }, [
                                    _c("td", [_vm._v(_vm._s(item.Factura))]),
                                    _c("td", [
                                      _vm._v(_vm._s(item.NotaCredito)),
                                    ]),
                                    _c(
                                      "td",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.CufeFE
                                                ? item.CufeFE.substring(0, 12) +
                                                    "..."
                                                : ""
                                            ) +
                                            " "
                                        ),
                                        item.CufeFE
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copy(
                                                                      item.CufeFE
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " mdi-content-copy "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Copiar CUFE"),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              item.CufeNC
                                                ? item.CufeNC.substring(0, 12) +
                                                    "..."
                                                : ""
                                            ) +
                                            " "
                                        ),
                                        item.CufeNC
                                          ? _c(
                                              "v-tooltip",
                                              {
                                                attrs: { bottom: "" },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "activator",
                                                      fn: function ({
                                                        on,
                                                        attrs,
                                                      }) {
                                                        return [
                                                          _c(
                                                            "v-icon",
                                                            {
                                                              attrs: {
                                                                color:
                                                                  "primary",
                                                                small: "",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.copy(
                                                                      item.CufeNC
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " mdi-content-copy "
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v("Copiar CUFE"),
                                                ]),
                                              ]
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color:
                                                item.DiferenciaIVA > 0
                                                  ? "orange"
                                                  : item.DiferenciaIVA < 0
                                                  ? "red"
                                                  : "green",
                                              dark: "",
                                              small: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    item.DiferenciaIVA
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color:
                                                item.DiferenciaTotal > 0
                                                  ? "orange"
                                                  : item.DiferenciaTotal < 0
                                                  ? "red"
                                                  : "green",
                                              dark: "",
                                              small: "",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.formatMoney(
                                                    item.DiferenciaTotal
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "td",
                                      [
                                        _c(
                                          "v-chip",
                                          {
                                            attrs: {
                                              color:
                                                item.Estado === "OK"
                                                  ? "green"
                                                  : "red",
                                              small: "",
                                              "text-color": "white",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(item.Estado) + " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                    _c("td", [_vm._v(_vm._s(item.Mensaje))]),
                                  ])
                                }),
                                0
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }